import React, { useContext, useEffect, useMemo, useState } from "react";
import Text from '../Text';
import { Box, makeStyles } from "@material-ui/core";
import Colors from "../../../helpers/Colors";
import { AppContext } from "../../../contexts/AppContext";
import {
    getAvailableDeliveryPartners,
    isOnGoingTransitionPeriodOrder,
    isNoDeliveryPartner,
    getSelectedDeliveryPartnerId
} from "../../../helpers/DeliveryPartnerHelper";
import assets from "../../../helpers/assets";
import { SELF_MANAGED_DELIVERY_PARTNER } from "../../../helpers/Constants";


const DeliveryToggle = ({ order }) => {

    const classes = useStyles();

    const { setDeliveryToggleDialogOpen, setActiveDeliveryToggleOrder, available3plPartners } = useContext(AppContext);

    const [driverAssigned, setDriverAssigned] = useState(false)

    const onToggleClick = () => {
        if (driverAssigned) return
        const orderAvailablePartners = getAvailableDeliveryPartners(
            order.deliveryPartnerSelection);
        if (orderAvailablePartners.length === 0) {
            return;
        }
        if (orderAvailablePartners.length === 1 && getCurrentDeliveryPartnerId()
            === orderAvailablePartners[0]?.id) {
            return;
        }
        setActiveDeliveryToggleOrder(order);
        setDeliveryToggleDialogOpen(true);
    }

    useEffect(() => {
        if (order && order.deliveryDetails.deliveryHistory) {

            let eventList = [];
            order.deliveryDetails.deliveryHistory.forEach(element => {
                eventList = [
                    ...eventList,
                    ...element.deliveryHistoryInfoList
                ];
            });
            eventList.sort(function (a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt);
            });

            const lastEvent = eventList[eventList.length - 1];
            if (lastEvent.deliveryEventType === 'DRIVER_ASSIGNED') {
                setDriverAssigned(true)
                setDeliveryToggleDialogOpen(false)
            } else {
                setDriverAssigned(false)
            }
        }
    }, [order.deliveryDetails])

    const get3PLCompanyName = () => {
        let currentDeliveryPartnerId = getCurrentDeliveryPartnerId();
        if (currentDeliveryPartnerId === null) {
            return '';
        }
        if (isOnGoingTransitionPeriodOrder(order)) {
            return available3plPartners.get(
                order?.deliveryDetails?.deliveryPartnerId);
        }
        //handle legacy default delivery mode
        if (currentDeliveryPartnerId.trim().length === 0
            && currentDeliveryPartnerId !== SELF_MANAGED_DELIVERY_PARTNER) {
            return 'In-House';
        }
        return available3plPartners.get(currentDeliveryPartnerId);
    }

    const getCurrentDeliveryPartnerId = () => getSelectedDeliveryPartnerId(
        order, available3plPartners);

    const getIcon = () => {
        let currentDeliveryPartnerId = getCurrentDeliveryPartnerId();
        if (currentDeliveryPartnerId === null) {
            return null;
        }
        return currentDeliveryPartnerId !== SELF_MANAGED_DELIVERY_PARTNER
            ? assets.driverCallInProgress.default : assets.expandMore.default
    }

    const renderNoDps = () => {
        return <div style={dpSizedBox}></div>;
    }

    return useMemo(() => {
        return (
            <>
                {isNoDeliveryPartner(order) ?
                    renderNoDps()
                    :
                    <Box
                        onClick={() => {
                            onToggleClick()
                        }}
                        className={`${classes.buttonContentContainer} ${driverAssigned
                            ? classes.buttonDisabled : ''}`}
                    >
                        <Box>
                            {<Text>{get3PLCompanyName()}</Text>}
                        </Box>
                        {!driverAssigned &&
                            <Box style={{ marginLeft: 8 }}>
                                <img src={getIcon()} alt='' width={16} />
                            </Box>
                        }
                    </Box>}
            </>
        )
    }, [order, order.tempSelected3pl]);
}

export default DeliveryToggle;

const dpSizedBox = {
    minHeight: 40,
    maxHeight: 40,
    minWidth: 145,
}

const useStyles = makeStyles(() => ({
    buttonContentContainer: {
        ...dpSizedBox,
        cursor: 'pointer',
        backgroundColor: Colors.boldBlue,
        borderRadius: 100,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        color: Colors.white,
        fontWeight: 'bold'
    },
    buttonDisabled: {
        backgroundColor: Colors.lightGray,
        color: Colors.darkGray,
        cursor: 'default'
    }
}));